// extracted by mini-css-extract-plugin
export default {"container":"Collapse_container__tjETz","header":"Collapse_header__y1Y+t","open":"Collapse_open__dxkuQ"};